export class StructuredData {
  // src - the full url to load
  // waitForPageLoad - still wait for the page load event on first hit

  elementsToStructuredData (elements) {
    if (elements?.length === undefined || elements.length === 0) { return [] }

    return {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: elements.map((element) => {
        return {
          '@type': 'Question',
          name: element.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: element.answer
          }
        }
      })
    }
  }

  elementsToScriptAndStructuredData (elements) {
    if (elements?.length) {
      return [{ type: 'application/ld+json', json: this.elementsToStructuredData(elements) }]
    } else {
      return []
    }
  }

  articleToScriptAndStructuredData (article, linkToAuthor) {
    return [{ type: 'application/ld+json', json: this.articleToStructuredData(article, linkToAuthor) }]
  }

  articleToStructuredData (article, linkToAuthor) {
    return {
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: article?.title,
      image: [article?.image?.data?.attributes?.url],
      datePublished: article?.publishedAt,
      dateModified: article?.updatedAt,
      author: [{
        '@type': 'Person',
        name: article?.author?.data?.attributes?.name,
        url: linkToAuthor
      }]
    }
  }
}
